var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0444 16.3939L16.3932 19.0454L34.9556 37.6061L37.6069 34.9546L19.0444 16.3939Z",
    fill: "#2AA7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0669 53.9321C11.0606 53.9321 7.29408 52.3721 4.46152 49.5384C1.62708 46.7059 0.0668945 42.9394 0.0668945 38.9321C0.0668945 34.9258 1.62689 31.1584 4.46152 28.3258L28.3256 4.46156C31.1581 1.62806 34.9246 0.0678711 38.9328 0.0678711C42.941 0.0678711 46.7056 1.62787 49.5384 4.46156C52.3728 7.29412 53.933 11.0606 53.933 15.0679C53.933 19.0751 52.373 22.8416 49.5384 25.6742L25.6743 49.5382C22.8418 52.3717 19.0751 53.9321 15.0669 53.9321ZM38.933 3.81787C35.9265 3.81787 33.101 4.98787 30.977 7.11281L7.11296 30.9771C4.98708 33.102 3.81708 35.9272 3.81708 38.9321C3.81708 41.937 4.98708 44.7622 7.11296 46.8872C9.23696 49.0121 12.0622 50.1821 15.0671 50.1821C18.0736 50.1821 20.8991 49.0121 23.0231 46.8872L46.8871 23.0231C49.013 20.8982 50.183 18.0729 50.183 15.0681C50.183 12.0632 49.013 9.23793 46.8871 7.113C44.7631 4.98806 41.9379 3.81787 38.933 3.81787Z",
    fill: "#2AA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6284 14.2905C33.1486 14.2905 32.669 14.1073 32.3028 13.7411C31.5704 13.0087 31.5704 11.8222 32.3028 11.0897L33.6284 9.76403C35.7635 7.62728 38.9531 6.98266 41.7547 8.11891C42.7141 8.50797 43.1756 9.6011 42.7874 10.5605C42.3993 11.5209 41.3006 11.9795 40.3449 11.5942C38.9441 11.0276 37.3492 11.3497 36.2799 12.4164L34.9543 13.7411C34.5881 14.1073 34.1081 14.2905 33.6284 14.2905Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.bd60ba7c65e643d6e0d316070112ea47.svg";
export { ForwardRef as ReactComponent };